<template>
	<page>
		<module>
			<view-list ref="view" selector :work-type="workType" :view-config="saasInfo.viewmanage" @load="loadSummary"  @change="getPayType">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="商户信息" colspan="2">
                            <c-select name="saas_ids" multiple async @search="searchSaas"></c-select>
                        </m-search-item>
						<m-search-item label="订单号">
							<c-input name="order_no"></c-input>
						</m-search-item>
						<m-search-item label="业务单号">
							<c-input name="business_order_no" placeholder="订单号/还款单号"></c-input>
						</m-search-item>
                        <m-search-item label="订单类型">
                            <c-select name="order_type" :options="ORDER_TYPE"></c-select>
                        </m-search-item>
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="支付流水号">
							<c-input name="third_party_order_no"></c-input>
						</m-search-item>
						<m-search-item label="销售渠道">
							<c-select name="channel_id" async @search="searchChannel"></c-select>
						</m-search-item>
						<m-search-item label="下单时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="售后时间" colspan="2">
							<c-datetime range start-name="after_sale_start_date" end-name="after_sale_end_date"></c-datetime>
						</m-search-item>
<!--                        <m-search-item label="核销状态" v-show="orderPayType == 1 || orderPayType == 2">
                            <c-select name="check_state" :options="CHECK_ORDER_STATUS"></c-select>
                        </m-search-item>-->
                        <m-search-item label="还款状态" v-show="orderPayType == 4">
                            <c-select name="credit_bill_state" :options="CREDIT_BILL_STATE"></c-select>
                        </m-search-item>
                        <m-search-item label="还款时间" colspan="2" v-show="orderPayType == 4">
                            <c-datetime range start-name="credit_bill_start_date" end-name="credit_bill_end_date"></c-datetime>
                        </m-search-item>
                        <m-search-item label="结算状态">
                            <c-select name="settle_state" :options="SALE_SETTLE_STATE"></c-select>
                        </m-search-item>
                        <m-search-item label="结算时间" colspan="2">
                        <c-datetime range start-name="settle_start_date" end-name="settle_end_date"></c-datetime>
                        </m-search-item>
					</m-search>

					<!-- 销售账单汇总统计 -->
					<div class="stats-bar flex">
						<div class="stats-card card-blue">
							<div class="stats-info">
								<div class="stats-title-row flex-start-center">
									<span class="stats-label">台数</span>
									<span class="stats-value">{{ formatNumber(summary.total_count) }}</span>
								</div>
							</div>
							<div class="stats-icon"><i class="tf tf-phone"></i></div>
						</div>
						<div class="stats-card card-orange">
							<div class="stats-info">
								<div class="stats-title-row flex-start-center">
									<span class="stats-label">总成本</span>
									<span class="stats-value">￥{{ formatMoney(summary.total_cost) }}</span>
								</div>
							</div>
							<div class="stats-icon">¥</div>
						</div>
						<div class="stats-card card-green">
							<div class="stats-info">
								<div class="stats-title-row flex-start-center">
									<span class="stats-label">销售总金额</span>
                                    <span class="stats-value">￥{{ formatMoney(summary.total_sale_amount - summary.total_refund_amount - summary.total_fee_amount) }}</span>
								</div>
								<div class="stats-summary-row flex-start-center">
									<span><label>待结算：</label>￥{{ formatMoney(summary.pending_amount) }}</span>
									<ins>|</ins>
									<span><label>已结算：</label>￥{{ formatMoney(summary.settled_amount) }}</span>
								</div>
							</div>
							<div class="stats-icon">¥</div>
						</div>
					</div>
				</template>

				<template #operate>
					<c-button v-if="auth('b_xiaohei_sale_bill_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

                <!-- 产品信息 -->
                <template #product_info="{data}">
                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
                </template>
				<!-- 订单类型 -->
				<template #order_type="{data}">
                    <c-state async tag dict="ORDER_TYPE" :value="data.order_type"></c-state>
				</template>
				<!-- 销售渠道 -->
				<template #channel_name="{data}">
                    <span v-if="data.order_type == 2">{{data.channel_name}}</span>
                    <span v-else>-</span>
				</template>

				<!-- 成本价 -->
				<template #cost_price="{data}">
					{{formatPrice(data.cost_price)}}
				</template>

				<!-- 销售价 -->
				<template #sale_price="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.sale_price)}}</span>
				</template>
				<!-- 售后金额 -->
				<template #refund_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.refund_amount)}}</span>
				</template>
				<!-- 手续费 -->
				<template #fee_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.fee_amount)}}</span>
				</template>

				<!-- 结算价 -->
				<template #settle_price="{data}">
                    <span v-if="data.settle_state == 1" style="color: green;">{{formatPrice(data.settle_price)}}</span>
                    <span v-else>-</span>
				</template>

				<!-- 支付渠道 -->
				<template #check_payment_channel="{data}">
					<c-state async tag dict="CHECK_PAYMENT_CHANNEL" :value="data.check_payment_channel"></c-state>
				</template>

                <!-- 下单时间 -->
                <template #create_date="{data}">
                    {{data.create_date || ''}}
                </template>

                <!-- 售后时间 -->
                <template #after_sale_date="{data}">
                    {{data.after_sale_date ||''}}
                </template>
                <!-- 核销状态 -->
                <template #check_state="{data}">
                    <span v-if="data.order_pay_type == 3">-</span>
                    <c-state v-else async tag dict="CHECK_ORDER_STATUS" :value="data.check_state"></c-state>
                </template>
                <!-- 结算状态 -->
                <template #settle_state="{data}">
                    <c-state async tag dict="SALE_SETTLE_STATE" :value="data.settle_state"></c-state>
                </template>
                <!-- 还款账单状态-->
                <template #credit_bill_state="{data}">
                    <c-state v-if="data.order_pay_type == 4" async dict="CREDIT_BILL_STATE" tag :value="data.credit_bill_state"></c-state>
                    <span v-else>-</span>
                </template>
                <!-- 订单渠道 -->
                <template #channel_id="{data}">
                    <c-state async tag dict="ORDER_CHANNEL" :value="data.channel_id"></c-state>
                </template>
                <!-- 支付渠道 -->
                <template #order_pay_type="{data}">
                    <c-state async tag dict="ORDER_PAY_TYPE" :value="data.order_pay_type"></c-state>
                </template>
                <!-- 采购金额 -->
                <template #purchase_price="{data}">
                    <span>{{formatPrice(data.purchase_price)}}</span>
                </template>
                <!-- 维修费用 -->
                <template #repair_cost="{data}">
                    <span>{{formatPrice(data.repair_cost)}}</span>
                </template>
<!--				<c-table-column
					type="button"
					label="操作"
					width="120"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button icon="tf-detail" @click="orderDetail(data)">订单详情</c-table-button>
					</template>
				</c-table-column>-->
			</view-list>
		</module>
	</page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'

export default {
	name: 'm_sale_bill',

	data() {
		return {
			workType: 116,
			defaultSearchData: {},
			summary: {},
            orderPayType:1//订单支付方式
        }
	},

	computed: {
		...mapState(['saasInfo']),
        ...asyncMapState(['CHECK_ORDER_STATUS','SALE_SETTLE_STATE','ORDER_TYPE','CREDIT_BILL_STATE'])
    },

	methods: {
        /*******搜索商户*****************/
        searchSaas(keyword, resolve){
            this.request({
                url: '/sys_saas/options',
                data: {
                    keyword: keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        /*********获取产品信息文字（品牌+型号+颜色+内存拼接，缺失时回退 product_name）**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || data.product_name || '-';
        },

		/*********加载汇总统计（随列表查询条件联动）**********/
		loadSummary(listData, searchParams) {
			this.request({
				url: '/financial/sale/bill/summary',
				data: searchParams || {},
				success: data => {
					this.summary = data || {};
				}
			});
		},
        /*******搜索订单支付方式*****************/
        getPayType(viewId) {
            //清除筛选条件
            this.$refs.view.$search.clear();
            this.request({
                url: '/sys_user_view/order_pay_type/filte',
                data: {
                    view_id: viewId
                },
                success: data => {
                    this.orderPayType = data||1;
                }
            })
        },
		/*********打开销售订单详情**********/
		orderDetail(data) {
            this.globalDialog('saleOrderDetail', {
                props: {
                    orderType: data.order_type
                },
                data: {
                    orderId: data.order_id
                }
            }, () => {
                this.$refs.view.update();
            });
		},

		/*********搜索销售渠道**********/
		searchChannel(keyword, resolve) {
			this.request({
				url: '/sale/product/channel/options',
				data: {
					keyword: keyword
				},
				success: data => {
					resolve((data || []).map(item => {
						return {
							name: item.channel_name,
							value: item.channel_id
						};
					}));
				}
			});
		},

		/*********格式化价格**********/
		formatPrice(price) {
			if (price === null || price === undefined || price === '') return '-';
			return '¥' + parseFloat(price).toFixed(2);
		},

        /**
         * 金额格式化（保留两位小数）
         */
        formatMoney(val) {
            if (val === undefined || val === null || val === '') {
                return '0.00';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0.00' : num.toFixed(2);
        },

        /**
         * 数量格式化
         */
        formatNumber(val) {
            if (val === undefined || val === null || val === '') {
                return '0';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0' : String(Math.round(num));
        },

		/*********获取核销状态文本**********/
		getCheckStateText(state) {
			return {0: '未核销', 1: '已核销', 2: '取消核销'}[state] || '-';
		},

		/*********获取核销状态样式**********/
		getCheckStateStyle(state) {
			let color = {0: '#ff9800', 1: '#52c41a', 2: '#999'}[state] || '#333';
			return {background: color};
		}
	}
}
</script>

<style lang="stylus" scoped>
.stats-bar {
    flex-shrink: 0;
    gap: 10px;
	border-top: 1px solid #F5F5F5;
	padding: 8px 12px;

    .stats-card {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        max-width: 360px;
        min-height: 56px;
        padding: 8px 16px;
        border-radius: 6px;
        color: #fff;
        box-sizing: border-box;
        overflow: hidden;

        &.card-blue {
            background: linear-gradient(90deg, #2563eb, #3b82f6);
        }

        &.card-orange {
            background: linear-gradient(90deg, #f97316, #fb923c);
        }

        &.card-green {
            background: linear-gradient(90deg, #16a34a, #22c55e);
        }

        .stats-info {
            position: relative;
            z-index: 1;

            .stats-title-row {
                display: flex;
                align-items: baseline;
                line-height: 24px;

                .stats-label {
                    font-size: 12px;
                    opacity: 0.95;
                }

                .stats-value {
                    margin-left: 6px;
                    font-size: 18px;
                    font-weight: bold;
                }
            }

            .stats-summary-row {
                gap: .5em;
                margin-top: 2px;
                font-size: 11px;

                ins {
                    text-decoration: none;
                    opacity: 0.6;
                }

                label {
                    opacity: 0.9;
                }
            }
        }

        .stats-icon {
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 32px;
            line-height: 1;
            opacity: 0.15;

            .tf {
                font-size: 32px;
            }
        }
    }
}

.m-product-info {
	&-name {
		gap: 6px;

		span {
			font-size: 14px;
		}
	}

	&-attr {
		margin-top: 4px;
		font-size: 12px;
		color: #999;
	}
}
</style>
